import React, { useEffect, useState } from 'react';

export default function StatementModal({ 
  open, 
  onAgree, 
  onCancel, 
  partnerName = '', 
  partnerIdNumber = '',
  orgName = '', 
  businessType = '' 
}) {
  const [seconds, setSeconds] = useState(5);

  // 每次open变为true时重置倒计时
  useEffect(() => {
    if (open) setSeconds(5);
  }, [open]);

  // 倒计时逻辑
  useEffect(() => {
    if (!open) return;
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [seconds, open]);

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        padding: 'clamp(20px, 5vw, 32px)',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto',
        boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
        animation: 'slideIn 0.3s ease-out'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '24px'
        }}>
          <div style={{
            marginBottom: '16px',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <img 
              src="/police_logo.png" 
              alt="警徽" 
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain'
              }}
            />
          </div>
          <h2 style={{
            color: '#2c3e50',
            margin: '0 0 8px 0',
            fontSize: 'clamp(18px, 5vw, 24px)',
            fontWeight: '700'
          }}>
            郑重说明
          </h2>
          <div style={{
            width: '60px',
            height: '3px',
            background: 'var(--primary-color)',
            margin: '0 auto',
            borderRadius: '2px'
          }}></div>
        </div>

        <div style={{
          background: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          padding: '28px',
          marginBottom: '24px',
          fontSize: '16px',
          lineHeight: '1.8',
          color: '#495057',
          textAlign: 'left'
        }}>
          <div style={{
            background: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '20px',
            fontSize: '16px',
            lineHeight: '1.6',
          color: '#856404'
          }}>
            <div style={{
              marginBottom: '12px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#495057',
              textAlign: 'left'
            }}>
              {partnerName ? `${partnerName} ${partnerIdNumber || '身份证号'}：` : '您：'}
            </div>
            
            <div style={{
              fontSize: '16px',
              lineHeight: '1.8',
              textAlign: 'justify'
            }}>
              您单位{orgName ? orgName : '（机构名称）'}正在申请办理{businessType ? businessType : '（业务类型）'}业务，同意办理的点击"知晓并同意"按钮提交申请，不同意的点击"放弃办理"按钮。
            </div>
          </div>
          
          <div style={{
            marginTop: '20px',
            padding: '16px',
            background: '#e7f3ff',
            border: '1px solid #b3d9ff',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#0056b3',
            textAlign: 'left'
        }}>
          <p style={{ margin: '0 0 12px 0', fontWeight: '600' }}>
              📋 用户须知：
          </p>
            <ol style={{ 
              margin: '0', 
              paddingLeft: '20px',
              lineHeight: '1.6'
            }}>
            <li style={{ marginBottom: '8px' }}>
              本次认证将收集您的人脸信息，用于身份验证和印章业务办理。
            </li>
            <li style={{ marginBottom: '8px' }}>
              我们承诺严格按照相关法律法规保护您的个人信息安全。
            </li>
            <li style={{ marginBottom: '8px' }}>
              认证过程中请确保光线充足，面部清晰可见，避免遮挡。
            </li>
            <li style={{ marginBottom: '8px' }}>
              认证结果将用于印章业务办理，请确保信息真实有效。
            </li>
            <li style={{ marginBottom: '8px' }}>
              您的签章一旦审核通过，即表明您的签章生效，表明您的真实意愿是认可与同意。
            </li>
            <li style={{ marginBottom: '0' }}>
              点击"知晓并同意"即表示您已阅读并接受上述所有条款，遵守系统流程及使用规则，同意办理本次业务。
            </li>
          </ol>
          </div>
          <div style={{
            marginTop: '16px',
            padding: '16px',
            background: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#856404'
          }}>
            <p style={{ margin: '0', fontWeight: '600' }}>
              ⚠️ 重要提示：
            </p>
            <p style={{ margin: '8px 0 0 0' }}>
              请确认以上信息无误后再进行下一步操作。一旦确认，将进入人脸核验流程。
          </p>
          </div>
        </div>

        <div style={{
          display: 'flex',
          gap: 'clamp(8px, 2vw, 12px)',
          justifyContent: 'center',
          flexWrap: 'nowrap',
          alignItems: 'center'
        }}>
          {onCancel && (
            <button
              onClick={onCancel}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                minWidth: 'fit-content'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#5a6268';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#6c757d';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              放弃办理
            </button>
          )}
          <button
            disabled={seconds > 0}
            onClick={onAgree}
            style={{
              background: seconds > 0 ? '#dee2e6' : 'var(--primary-color)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 32px',
              fontSize: '16px',
              cursor: seconds > 0 ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              minWidth: 'fit-content'
            }}
            onMouseOver={(e) => {
              if (seconds === 0) {
                e.target.style.background = 'var(--primary-hover)';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseOut={(e) => {
              if (seconds === 0) {
                e.target.style.background = 'var(--primary-color)';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {seconds > 0 ? `知晓并同意 (${seconds}s)` : '知晓并同意'}
          </button>
        </div>

        {seconds > 0 && (
          <div style={{
            textAlign: 'center',
            marginTop: '16px',
            color: '#6c757d',
            fontSize: '12px'
          }}>
            请仔细阅读郑重说明后再点击知晓并同意
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
}